module.exports = __webpack_public_path__ + "img/input.62120d8b.png";